import { render, staticRenderFns } from "./NewCampaign.vue?vue&type=template&id=4544952b&scoped=true&"
import script from "./NewCampaign.vue?vue&type=script&lang=js&"
export * from "./NewCampaign.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaign.vue?vue&type=style&index=0&id=4544952b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544952b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCardTitle,VProgressLinear})
